/**
 * Created by Ella Ma on 7/10/2019.
 * Description:
 * DashboardGuard
 *
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { DashboardEditorComponent } from './dashboard-editor/dashboard-editor.component';

@Injectable({
    providedIn: 'root'
})
export class DashboardGuard implements CanDeactivate<DashboardEditorComponent> {
    constructor(
        private _alertWindow: AlertWindowService,
    ) { }
    canDeactivate(component: DashboardEditorComponent): Observable<boolean> | Promise<boolean> | boolean {
        if (component.dashboardEditorSubChromeConfig.changeRouterBySelf) {
            return true;
        }
        return this._alertWindow.warn('You have unsaved changes',
            ['Are you sure you want to leave this page?'], 'Leave', 'Stay')
            .pipe(map((result: boolean) => {
                return result;
            }));
    }
}
